import { Box, Button, Stack, Typography } from '@mui/material';

import { useLocalization } from 'localization';
import BranchCoverImage from './BranchCoverImage';
import BranchAvatar from './BranchAvatar';
import DataGridTable from 'components/v2/table/DataGridTable';
import { useBranchSetting } from 'hooks/services/useBranchSetting';
import DefaultBranchOptions from 'components/v2/shared/DefaultBranchOptions';
import PlusIcon from 'components/v2/icons/PlusIcon';
import { MODAL_ID, MODALS_STORE } from 'constants/ui/modal';
import { useGetBranchInformationByIdApi } from 'api/branches/query';
import { useCurrentBranch } from 'hooks/services/useCurrentBranch';

const BranchSettings = () => {
  const { t } = useLocalization();
  const { ui } = useBranchSetting();
  const { toggleModal } = MODALS_STORE.branch();

  const { clientStates, actions } = useCurrentBranch();
  const { data: branchDetail, isLoading, isFetching } = useGetBranchInformationByIdApi(clientStates.branches ?? '');

  return (
    <Stack gap={2}>
      {/* Branch Information */}
      <Stack>
        <BranchCoverImage data={branchDetail} loading={isLoading || isFetching} />
        <Box sx={{ marginTop: -8, marginLeft: 4 }}>
          <BranchAvatar branchDetail={branchDetail} />
        </Box>
      </Stack>
      {/* Set default branches */}
      <DefaultBranchOptions handleChange={actions.handleChange} />
      {/* Connected Accounts */}
      <Stack gap={2}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h4">{t('accountSetting.connectedAccounts')}</Typography>
          <Button
            variant="contained"
            size={'medium'}
            startIcon={<PlusIcon />}
            onClick={() => toggleModal(MODAL_ID.ADD_EDIT_SOCIAL_MEDIA_ACCOUNT, { isEdit: false })}
          >
            {t('accountSetting.addAccount')}
          </Button>
        </Stack>
        <Box sx={{ maxHeight: 400, overflow: 'auto' }}>
          <DataGridTable
            rows={branchDetail?.socialMedias ?? []}
            columns={ui.table.columns ?? []}
            isHideFooter
            emptyText={t('common.terms.noData')}
          />
        </Box>
      </Stack>
    </Stack>
  );
};

export default BranchSettings;
